import React from 'react'

interface Props {
    children?: React.ReactNode
}
const HorizontalCardImageContainer: React.FC<Props> = props => {
    return <>{props.children}</>
}

export default HorizontalCardImageContainer
